<template>
  <div class="hero-content">
    <Logo />
    <div class="hero-overlay">
      <div class="hero">
        <div class="hero-inner">
          <!-- HERO BLOCK FOR MESSAGING OPTIONS -->
          <HeroContent :message="getMessage()" :status="partyState" />
          <!-- Counter  -->
          <Countdown v-if="partyState === 'pre'" />
          <JoinIn v-if="partyState === 'pre'" />
        </div>
      </div>
    </div>
    <Marquee color="black bottom" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import HeroContent from "./HeroContent"
import Countdown from "./Countdown"
import JoinIn from "./JoinIn"
import Marquee from "./Marquee"
import Logo from "./Logo"

export default {
  data: () => ({}),

  methods: {
    getMessage() {
      if (this.partyState == "pre") {
        return "Join us at 5pm this Saturday 11th!"
      } else if (this.partyState == "broken") {
        return "Name not down? Take the quiz and pick up your party pack for an invite straight to your inbox!"
      } else if (this.partyState == "ended" || this.partyState == "cancelled") {
        return "Thanks for coming. We will be in touch about more parties with our Bleach Stylists xx"
      }
      return "Bleach Hair Party"
    }
  },

  components: {
    Countdown,
    HeroContent,
    JoinIn,
    Marquee,
    Logo
  },

  created() {},

  computed: {
    ...mapState("partyStore", ["activeParty"]),

    partyState() {
      return this.activeParty?.state
    }
  }
}
</script>

<style lang="scss">
$white: #fff;
$break-mid: 840px;
$break-large: 720px;
@mixin prefix($property, $value, $prefixes: ()) {
  @each $prefix in $prefixes {
    #{'-' + $prefix + '-' + $property}: $value;
  }
  #{$property}: $value;
}

.hero-overlay {
  // position: fixed;
  // top: 0;
  // left: 0;
  width: 100vw;
  min-height: 100vh;
  background: url("/assets/bg_green.jpg");
  background-size: cover;
  z-index: 50;
  font-family: "Poppins", sans-serif;
  color: $white;

  -webkit-box-sizing: unset;
  -moz-box-sizing: unset;
  box-sizing: unset;
}
.hero {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  display: table;
  overflow: hidden;
}
.hero-content {
  position: relative;
}
.hero-inner {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  padding: 60px 40px;
  @media screen and (max-width: $break-mid) {
    padding: 150px 20px 20px 20px;
  }
  @media screen and (max-width: 520px) {
    padding: 60px 0px 20px 0px;
  }
  @media screen and (max-width: 420px) {
    padding: 150px 0px 40px 0px;
  }
  @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
    padding: 20px 20px 40px 20px;
  }
}

@keyframes slide-out {
  100% {
    left: -25px;
  }
}

@-webkit-keyframes slide-out {
  100% {
    left: -25px;
  }
}
</style>
